interface ComputerMarketplaceSVGProps {
  color: string;
  style: React.CSSProperties;
}

const ComputerMarketplaceSVG = ({
  color,
  style,
}: ComputerMarketplaceSVGProps) => (
  <svg
    style={style}
    xmlns="http://www.w3.org/2000/svg"
    width="54"
    height="48"
    viewBox="0 0 54 48"
    fill="none"
  >
    <g clipPath="url(#clip0_678_13640)">
      <path
        d="M28.09 5.69006L26.79 2.11006C26.44 1.18006 25.54 0.560059 24.55 0.560059H23.25"
        stroke={color}
        strokeWidth="1.12"
        strokeMiterlimit="10"
        strokeLinecap="round"
      />
      <path
        d="M38.3702 25.3701C38.3702 26.4601 37.4802 27.3501 36.3902 27.3501C35.3002 27.3501 34.4102 26.4601 34.4102 25.3701C34.4102 24.2801 35.3002 23.3901 36.3902 23.3901C37.4802 23.3901 38.3702 24.2801 38.3702 25.3701Z"
        stroke={color}
        strokeWidth="1.12"
        strokeMiterlimit="10"
        strokeLinecap="round"
      />
      <path
        d="M48.0704 25.3701C48.0704 26.4601 47.1804 27.3501 46.0904 27.3501C45.0004 27.3501 44.1104 26.4601 44.1104 25.3701C44.1104 24.2801 45.0004 23.3901 46.0904 23.3901C47.1804 23.3901 48.0704 24.2801 48.0704 25.3701Z"
        stroke={color}
        strokeWidth="1.12"
        strokeMiterlimit="10"
        strokeLinecap="round"
      />
      <path
        d="M35.3498 18.2099H50.3098L53.3298 8.82994C53.8298 7.27994 52.6698 5.68994 51.0398 5.68994H28.0898L32.3698 18.6899C32.8098 20.0399 34.0698 20.9499 35.4898 20.9499H48.6298"
        stroke={color}
        strokeWidth="1.12"
        strokeMiterlimit="10"
        strokeLinecap="round"
      />
      <path
        d="M14.0601 5.68994L21.2501 9.76994L14.0601 13.9199L6.87012 9.76994L14.0601 5.68994Z"
        stroke={color}
        strokeWidth="1.12"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M14.0601 22.22L6.87012 18.07V9.77002"
        stroke={color}
        strokeWidth="1.12"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M14.0601 22.22L21.2501 18.07V9.77002"
        stroke={color}
        strokeWidth="1.12"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M14.0601 13.9199V19.4399"
        stroke={color}
        strokeWidth="1.12"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M23.2495 0.560059H4.04955C2.38955 0.560059 1.03955 1.91006 1.03955 3.57006V27.5601C1.03955 29.2201 2.38955 30.5701 4.04955 30.5701H38.4496C40.1096 30.5701 41.4595 29.2201 41.4595 27.5601V20.9501"
        stroke={color}
        strokeWidth="1.12"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M41.4697 5.69006V3.57006C41.4697 1.91006 40.1197 0.560059 38.4597 0.560059H28.4297"
        stroke={color}
        strokeWidth="1.12"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M10.9399 30.5698L9.10986 35.2198H21.2499H33.3999L31.5699 30.5698"
        stroke={color}
        strokeWidth="1.12"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M38.2498 38.7402L41.7698 45.0902C42.2998 46.0402 41.6098 47.2202 40.5198 47.2202H1.98979C0.899788 47.2202 0.209788 46.0502 0.739788 45.0902L4.25979 38.7402H38.2498Z"
        stroke={color}
        strokeWidth="1.12"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M39.7798 13.5099C39.7798 14.4399 40.5298 15.1899 41.4698 15.1899C42.4098 15.1899 43.1598 14.4399 43.1598 13.5099C43.1598 12.5799 42.4698 12.1499 41.4698 11.8199C40.5898 11.5299 39.7798 11.0699 39.7798 10.1299C39.7798 9.18994 40.5298 8.43994 41.4698 8.43994C42.4098 8.43994 43.1598 9.18994 43.1598 10.1299"
        stroke={color}
        strokeWidth="1.12"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M41.4697 7.50977V8.45977"
        stroke={color}
        strokeWidth="1.12"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M41.4697 15.1899V16.1399"
        stroke={color}
        strokeWidth="1.12"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M31.6101 27.2002H22.3501"
        stroke={color}
        strokeWidth="1.12"
        strokeMiterlimit="10"
        strokeLinecap="round"
      />
      <path
        d="M27.1001 23.54H22.3501"
        stroke={color}
        strokeWidth="1.12"
        strokeMiterlimit="10"
        strokeLinecap="round"
      />
    </g>
    <defs>
      <clipPath id="clip0_678_13640">
        <rect width="54.01" height="47.77" fill={color} />
      </clipPath>
    </defs>
  </svg>
);

export default ComputerMarketplaceSVG;
